import classNames from 'classnames'
import React from 'react'

import { Button } from '../button/button.js'
import { CopyIcon } from '../icon/icon.js'

export interface CopyProps {
    textToCopy: string
    onCopy?: (text: string) => void
    className?: string
}

export const Copy = (props: CopyProps): JSX.Element => {
    const { onCopy, textToCopy } = props

    const className: string = classNames('copy', props.className)

    const getTrigger = () => (
        <Button
            className="copy__button"
            text="Copy"
            iconLeft={CopyIcon}
            style="link"
            isLabelHidden={true}
            iconClassName="button__icon--large"
            onClick={() => handleClick()}
        />
    )

    const copyText = async () => {
        return await navigator.clipboard.writeText(textToCopy)
    }

    const handleClick = () => {
        void copyText().then(() => {
            if (onCopy) {
                onCopy(textToCopy)
            }
        })
    }

    return <div className={className}>{getTrigger()}</div>
}
